import { render, staticRenderFns } from "./BenefitTypeCreate.vue?vue&type=template&id=24e407b2&"
import script from "./BenefitTypeCreate.js?vue&type=script&lang=js&"
export * from "./BenefitTypeCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports